export default __webpack_public_path__ + "static/media/css.5721a392.png";